import React from 'react';
import { Button } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import StudentCard from './StudentCard';

const StudentGrid = ({ students = [], onDelete, page = 1, setPage, total = 0, pageSize = 10 }) => {
  const totalPages = Math.ceil(total / pageSize);

  // Generate page numbers with ellipsis
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (page > 3) pages.push('...');
      const start = Math.max(2, page - 1);
      const end = Math.min(totalPages - 1, page + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (page < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <div>
      <div className="row g-4">
        {students.map(student => (
          <div key={student._id} className="col-12 col-md-6 col-lg-4">
            <StudentCard student={student} onDelete={onDelete} />
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="data-table-pagination mt-3">
          <div className="pagination-info">
            {total === 0 ? (
              <span>No entries</span>
            ) : (
              <span>
                Showing {((page - 1) * pageSize) + 1} to{' '}
                {Math.min(page * pageSize, total)} of {total} entries
              </span>
            )}
          </div>
          <div className="pagination-controls">
            <Button
              variant="light"
              size="sm"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
              className="me-2"
            >
              <FaChevronLeft size={12} />
            </Button>
            {getPageNumbers().map((pageNum, index) => (
              pageNum === '...' ? (
                <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
              ) : (
                <Button
                  key={pageNum}
                  variant={page === pageNum ? 'dark' : 'light'}
                  size="sm"
                  onClick={() => setPage(pageNum)}
                  className="me-2"
                >
                  {pageNum}
                </Button>
              )
            ))}
            <Button
              variant="light"
              size="sm"
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages}
            >
              <FaChevronRight size={12} />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentGrid;
